<template>
  <div id="app" :class="{'home py-5 md:py-0' : auth && !isFile}">
    <div v-if="isUat" class="uat-top-bar">U A T</div>
    <site-menu ref="site_menu" v-if="auth && !isFile" :user-sites="userSites" :current-site="currentSite"></site-menu>
    <top-bar v-if="auth && !isFile" @toggle-site-menu="toggleSiteMenu" :current-site="currentSite" :pages="pages" :unread="unread" :notifications="notifications" @load-notification="loadNotifications" :notification-end="notificationEnd" @check-has-unread="loadNotificationStatistics" :notification-loading="notificationLoading"></top-bar>
    <mobile-menu ref="mobile_menu" @toggle-mobile-menu="toggleMobileMenu" :current-site="currentSite" :permissions="permissions" @pass-pages="getPages"></mobile-menu>

    <div :class="{'flex overflow-hidden': auth && !isFile}">
      <mobile-top-bar v-if="auth && !isFile" :current-site="currentSite" :permissions="permissions" @toggle-mobile-menu="toggleMobileMenu"></mobile-top-bar>
      <side-menu ref="side_menu" v-if="auth && !isFile" :current-site="currentSite" :permissions="permissions" @pass-pages="getPages"></side-menu>
      <!-- BEGIN: Content -->
      <div :class="{'content': auth && !isFile}">
        <router-view :auth="auth" :all-sites="allSites" :user-sites="userSites" :current-site="currentSite" :permissions="permissions" :profile="profile"></router-view>
      </div>
      <!-- END: Content -->
    </div>

    <div v-if="auth && !isFile && isUat" class="ai-chat-float">
      <div v-if="aiChatOpen" class="ai-chat-panel">
        <div v-if="false" class="ai-chat-panel__header">
          <span>AI 智能助手</span>
          <button type="button" class="ai-chat-panel__close" aria-label="關閉" @click="aiChatOpen = false">
            <font-awesome-icon icon="fa-solid fa-xmark" />
          </button>
        </div>
        <div class="ai-chat-panel__body">
          <iframe v-if="aiEmbedUrl" :src="aiEmbedUrl" class="iframe-viewer" frameborder="0" title="AI 智能助手"></iframe>
          <div v-else-if="aiErrorMsg" class="alert alert-danger show m-3" role="alert">{{ aiErrorMsg }}</div>
          <div v-else class="ai-chat-panel__status">
            <font-awesome-icon icon="fa-solid fa-spinner" spin class="fa-2x" />
          </div>
        </div>
      </div>
      <button type="button" class="ai-chat-bubble" :aria-expanded="aiChatOpen ? 'true' : 'false'" @click="toggleAiChat">
        <font-awesome-icon :icon="aiChatOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-robot'" />
        <span>AI 智能助手</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentSite: null,
      profile: null,

      isUat: (process.env.VUE_APP_ENV === 'uat'),
      auth: false,
      isFile: false,
      userSites: [],
      allSites: [],
      permissions: [],
      unread: 0,
      notifications: [],
      notificationPage: 1,
      notificationEnd: false,
      pages: [],
      menuItems: [],
      notificationLoading: false,
      aiChatOpen: false,
      aiEmbedUrl: null,
      aiErrorMsg: null,
      aiEmbedRequestId: 0
    }
  },
  watch: {
    async '$route'(val) {
      // this.$nextTick(() => {
      // })
      if (this.auth) {
        if (this.currentSite) {
          await this.getCurrentPermission()
        } else {
          if (this.currentSite == null || this.currentSite === '') {
            this.toggleSiteMenu()
          }
        }

        this.loadNotificationStatistics()
        this.notifications = []
        this.notificationPage = 0
        this.notificationEnd = false
        this.loadNotifications()
      }
    },
    currentSite(val, oldVal) {
      if (!oldVal || val.site_id !== oldVal.site_id) {
        this.loadMenuItems()
      }
    },
    menuItems(val) {
      this.$refs.side_menu.menuItems = val
      this.$refs.mobile_menu.menuItems = val
    }
  },
  mounted() {
    this.$moment().locale('zh-hk')
    this.isLoggedIn()

    if (this.$router.currentRoute.name === 'file') {
      this.isFile = true
    }
  },
  methods: {
    async loadMenuItems() {
      if (this.currentSite) {
        this.menuItems = [
          { name: '報告板', url: '/announcements', icon: 'fa-solid fa-rss', sitePermission: this.currentSite.is_announcement_enabled, permission: 'site.announcement.view' },
          { name: '行事曆', url: '/calendar', icon: 'fa-regular fa-calendar', sitePermission: this.currentSite.is_calendar_enabled, permission: 'site.calendar.view' },
          { name: '通訊錄', url: '/address-books', icon: 'fa-regular fa-address-book', sitePermission: this.currentSite.is_phone_directory_enabled, permission: 'site.phone_directory.view' },
          { name: '檔案櫃', url: '/library', icon: 'fa-regular fa-hard-drive', sitePermission: true, permission: null },
          { name: '內聯網申請表', url: '/workflows', icon: 'fa-solid fa-table-columns', sitePermission: this.currentSite.is_workflow_enabled, permission: ['system.workflow.email-workflow', 'system.workflow.account-workflow'] },
          { name: '問卷/電子表格', url: '/forms', icon: 'fa-regular fa-file-lines', sitePermission: this.currentSite.is_form_enabled, permission: 'site.form.view' },
          { name: '會議室及資源預借', url: '/resource-bookings', icon: 'fa-solid fa-clipboard-check', sitePermission: this.currentSite.is_resource_booking_enabled, permission: ['site.resource-booking.view'] },
          { name: 'FAQ', url: '/faq', icon: 'fa-regular fa-circle-question', sitePermission: this.currentSite.is_knowledge_base_enabled, permission: 'site.knowledge_base.view' },
          { name: '討論區', url: '/forum', icon: 'fa-regular fa-comment', sitePermission: this.currentSite.is_forum_enabled, permission: 'site.forum.view' },
          { name: '執行報告', url: '/performance-report', icon: 'fa-regular fa-file', sitePermission: true, permission: 'centre.performance-report.fill' },
          { name: '系統管理', url: '/management', icon: 'fa-solid fa-gear', sitePermission: true, permission: ['site.manage'] }
        ]

        if (this.isUat) {
          this.menuItems.push({
            name: 'AI 智能助手',
            url: '/ai-assistant',
            icon: 'fa-solid fa-robot',
            sitePermission: true,
            permission: null
          })
        }
        await this.loadMenuShortcuts()
      }
    },
    async loadMenuShortcuts(site) {
      const response = await this.getSiteMenuShortcuts(this.currentSite.site_id)

      for (let i = 0; i < response.length; i++) {
        if (response[i].is_effective) {
          this.menuItems.push({
            name: response[i].name,
            url: response[i].url,
            target: response[i].is_open_newwindow ? '_blank' : '',
            icon: 'fa-solid fa-link',
            externalLink: true
          })
        }
      }
    },
    toggleMobileMenu(val) {
      this.$refs.mobile_menu.show = !this.$refs.mobile_menu.show
    },
    async isLoggedIn() {
      // Check accessToken exist
      const accessToken = this.$cookies.get('accessToken')
      if (accessToken == null || accessToken === '') {
        // Check user is logged in or not
        this.auth = false
        // Store before path
        if (this.$route.path != null && this.$route.path !== '' && this.$route.path !== '/' && this.$route.path !== '/forgot-password' && this.$route.path !== '/reset-password') {
          this.$cookies.set('enterUrl', this.$route.path)
          this.$router.push('/')
        }
      } else {
        await this.getProfileAndCurrentSite()
        // await this.getUserSites()
        await this.getAllSites()

        if (this.currentSite == null || this.currentSite === '') {
          this.toggleSiteMenu()
        }
      }
    },
    getPages(value) {
      this.pages = value
    },
    async getProfileAndCurrentSite() {
      this.auth = true

      const response = await this.getProfile()
      this.profile = response.profile
      this.userSites = response.sites
      await this.$cookies.set('profile', response.profile)
      await this.$cookies.set('sites', response.sites)

      // const departmentId = response.profile.current_department_id

      const currentSite = await this.$cookies.get('currentSite')

      if (currentSite == null || currentSite === '') {
        if (response.sites.length > 0) {
          this.currentSite = response.sites[0]
          this.setCurrentSiteCookies(this.currentSite)
        }
      } else if (this.currentSite == null || this.currentSite.site_id !== currentSite.site_id) {
        this.currentSite = currentSite
      }
      // Get Permissions
      await this.getCurrentPermission()

      // Get Notifications
      // this.loadNotificationStatistics()
      this.loadNotificationStatistics()
      this.loadNotifications()
    },
    async removeProfile(cookieOnly = false) {
      await this.$cookies.remove('profile')
      if (!cookieOnly) {
        this.profile = null
      }
    },
    async removeCurrentSite(cookieOnly = false) {
      await this.$cookies.remove('currentSite')
      if (!cookieOnly) {
        this.currentSite = null
      }
    },
    async setCurrentSiteCookies(currentSite) {
      delete currentSite.permissions
      delete currentSite.roles
      await this.$cookies.set('currentSite', currentSite)
    },
    async getUserSites() {
      const response = await this.getProfile()
      this.userSites = response.sites
    },
    async getAllSites() {
      this.allSites = await this.getSites()
    },
    async getCurrentPermission() {
      if (this.currentSite != null) {
        const response = await this.getUserSitePermission(this.currentSite.site_id, true)
        if (response != null) {
          this.permissions = response.permissions
        }
      }
    },
    async loadNotificationStatistics() {
      const response = await this.getNotificationStatistics()
      if (response != null) {
        this.unread = response.unread ? response.unread : 0
      }
    },
    async loadNotifications() {
      this.notificationLoading = true
      const response = await this.getNotifications(10, this.notificationPage++)

      if (response.length === 0) {
        this.notificationEnd = true
      } else {
        this.notifications = [...this.notifications, ...response]
      }

      this.notificationLoading = false
    },
    toggleAiChat() {
      if (this.aiChatOpen) {
        this.aiChatOpen = false
        return
      }

      this.openAiChat()
    },
    async openAiChat() {
      this.aiChatOpen = true
      this.aiEmbedUrl = null
      this.aiErrorMsg = null
      await this.loadAiEmbedUrl()
    },
    async loadAiEmbedUrl() {
      const requestId = ++this.aiEmbedRequestId
      const response = await this.getAiAssistantEmbedUrl()

      if (requestId !== this.aiEmbedRequestId || !this.aiChatOpen) {
        return
      }

      if (response && response.code === 0) {
        this.aiEmbedUrl = response.data?.url
      } else {
        this.aiErrorMsg = response?.data?.message ?? 'AI 助手暫時未能使用'
      }
    },
    toggleSiteMenu(val) {
      if (!this.$refs.site_menu) {
        return
      }

      this.$refs.site_menu.show = !this.$refs.site_menu.show
    },
    async updateCurrentSiteData(siteId = null) {
      let currentSiteId = null
      if (siteId == null) {
        const currentSite = this.$cookies.get('currentSite')
        // console.log(currentSite)
        currentSiteId = currentSite.site_id
      } else {
        currentSiteId = siteId
      }

      this.currentSite = await this.getSite(currentSiteId)
      this.setCurrentSiteCookies(this.currentSite)
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .uat-top-bar {
    position: fixed;
    background: #de2f2f;
    background: linear-gradient(180deg,rgba(222, 47, 47, 1) 19%, rgba(255, 255, 255, 0) 100%);
    color: #fff;
    font-weight: bold;
    display: block;
    left: 0;
    right: 0;
    top: 0;
    text-align: center;
    padding-top: 0.05rem;
    padding-bottom: 0.5rem;
    z-index: 999;
  }

  .ai-chat-float {
    position: fixed;
    right: 1.5rem;
    bottom: 1.5rem;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.75rem;
  }

  .ai-chat-bubble {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    border: 0;
    border-radius: 999px;
    padding: 0.85rem 1.15rem;
    color: #fff;
    background-color: rgb(var(--color-primary));
    box-shadow: 0 10px 24px rgb(0 0 0 / 0.18);
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
  }

  .ai-chat-panel {
    width: min(420px, calc(100vw - 2rem));
    height: min(640px, calc(100vh - 8rem));
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 16px 40px rgb(0 0 0 / 0.2);
  }

  .ai-chat-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    color: #fff;
    background-color: rgb(var(--color-primary));
    font-weight: 600;
  }

  .ai-chat-panel__close {
    border: 0;
    background: transparent;
    color: #fff;
    cursor: pointer;
    line-height: 1;
  }

  .ai-chat-panel__body {
    flex: 1;
    min-height: 0;
    background: #fff;
  }

  .ai-chat-panel__status {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .iframe-viewer {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
